import request from '../utils/request';

const BASE_URL = '/complaint-type-config';

const complaintTypeConfigApi = {
  // 分页查询投诉类型配置列表
  listComplaintTypeConfigs(params = {}) {
    const {
      page = 1, 
      pageSize = 10, 
      sortField = 'create_time', 
      sortOrder = 'desc',
      ...queryParams
    } = params;

    return request.post(`${BASE_URL}/list`, {
     
        page,
        pageSize,
        sortField,
        sortOrder,
        ...queryParams
      
    });
  },

  // 创建投诉类型配置
  createComplaintTypeConfig(configData) {
    return request.post(`${BASE_URL}/create`, configData);
  },

  // 更新投诉类型配置
  updateComplaintTypeConfig(id, configData) {
    return request.put(`${BASE_URL}/update/${id}`, configData);
  },

  // 更新投诉类型配置状态
  updateComplaintTypeConfigStatus(id, status) {
    return request.put(`${BASE_URL}/status/${id}`, null, {
      params: { status }
    });
  }
};

export default complaintTypeConfigApi;
